import { render, staticRenderFns } from "./ConnectionCard.vue?vue&type=template&id=33da0f74"
import script from "./ConnectionCard.vue?vue&type=script&lang=js"
export * from "./ConnectionCard.vue?vue&type=script&lang=js"
import style0 from "./ConnectionCard.vue?vue&type=style&index=0&id=33da0f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports